// extracted by mini-css-extract-plugin
export default {"addRecipeWrapper":"Gb14c23 G579119","dropperContainer":"G985c30 G579119"};